module.exports = __webpack_public_path__ + "static/media/shereen_ahmed.a37afe3c.png";